import { render, staticRenderFns } from "./RegistrationThanks.vue?vue&type=template&id=17b75eca&scoped=true"
import script from "./RegistrationThanks.vue?vue&type=script&lang=js"
export * from "./RegistrationThanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b75eca",
  null
  
)

export default component.exports